"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffectCancelVfxStepArgs = void 0;
const uuid_1 = require("uuid");
class EffectCancelVfxStepArgs {
    constructor(effectId, location) {
        this.effectId = effectId;
        this.location = location;
        this.__typeName = "EffectCancel";
        this.id = (0, uuid_1.v4)();
    }
}
exports.EffectCancelVfxStepArgs = EffectCancelVfxStepArgs;
